import React from "react";
import cross from "../images/new/cross.svg";

function Popup(props) {
  return (
    <div className={props.popupClass}>
      <div className="modal-overlay modal-toggle"></div>
      <div className={props.animationClass}>
        <div className="modal-header">
          <button
            className="modal-close modal-toggle"
            onClick={props.handleClose}
          >
            <img src={cross} alt="" />
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-content">
            <form action="#" method="post" id="getStarted">
              <input
                type="text"
                name="wallet"
                autocomplete="off"
                id="wallet"
                placeholder="Wallet Address"
                data-required
                data-error-message="please enter wallet address"
              />
              <input
                type="text"
                name="discord"
                autocomplete="off"
                id="discord"
                placeholder="Discord ID"
                data-required
                data-error-message="please enter discord ID"
              />
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Popup;
